<div
	#mirRules
	class="mir-rules-container"
>
	<h1 class="heading-1">Missing Inspection Settings</h1>
	<ng-container *ngIf="view !== 'wizard'">
		<div class="controls-container">
			<app-control-box
				*ngFor="let c of controls"
				[icon]="c.icon"
				[headerText]="c.headerText"
				[detailText]="c.detailText"
				[value]="c.value"
				[isSelected]="c.isSelected"
				(controlBoxEmitter)="controlBoxClick($event)"
			></app-control-box>
		</div>
		<app-rule-summary
			[rule]="clickedRule"
			[view]="view"
			(closeBtnClicked)="ruleSummaryCloseClicked()"
		></app-rule-summary>
	</ng-container>

	<app-rules-table
		*ngIf="view === 'rules'"
		[context]="restoreRulesPageContext"
		(rowClicked)="ruleRowClicked($event)"
		(selectedRowsEmitter)="selectedRows($event)"
		(rowsDeleted)="rulesWereDeleted()"
	></app-rules-table>

	<app-assets-table
		*ngIf="view === 'assets'"
		[context]="restoreAssetsPageContext"
		(rowClicked)="assetRowClicked($event)"
		(selectedRowsEmitter)="selectedRows($event)"
		(clearRuleClicked)="onClearRuleClicked()"
	></app-assets-table>

	<app-wizard
		*ngIf="view === 'wizard'"
		[data]="clickedRule"
		(cancelled)="onWizardCancelled()"
		(saveCompleted)="onSaveCompleted()"
	></app-wizard>
</div>
